module.exports = __webpack_public_path__ + "static/media/logo.c70cf2c3.png";